<template>
  <div class="mainSection">
    <div class="container">
      <Interface :buttons="buttons" />
    </div>
  </div>
</template>

<script>
import Interface from 'components/setting/interface/Interface'
export default {
  name: 'settingInterfaceDesktop',
  components: { Interface },
  data() {
    return {}
  },
  computed: {
    buttons() {
      return [
        {
          text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
          icon: 'interface-common-pages',
          link: 'settingInterfaceWebPages',
        },
        {
          text: this.localStorage.translations.pages.pages.buttons.nastroyki,
          icon: 'pages-settings',
          link: 'settingInterfaceWebSetting',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWebSettingPages',
            },
            {
              text: this.localStorage.translations.pages.setting.pages['lichnyy-kabinet'],
              icon: 'pages-settings-personal_area',
              link: 'settingInterfaceWebSetting_personalArea',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.sections,
                  icon: 'interface-common-sections',
                  link: 'settingInterfaceWebSetting_personalArea_sections',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.labels,
                  icon: 'interface-common-labels',
                  link: 'settingInterfaceWebSetting_personalArea_labels',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting_personalArea_buttons',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_Roles_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-personal_area'][
                        'dialog-new_address'
                      ]['title_add'],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_personalArea_dialogs_newAddress',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['roli'],
              icon: 'pages-settings-roles',
              link: 'settingInterfaceWebSetting_Roles',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_Roles_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.labels,
                  icon: 'interface-common-labels',
                  link: 'settingInterfaceWebSetting_Roles_labels',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting_Roles_buttons',
                },
                {
                  text: this.localStorage.translations.pages['setting-roles']['access-types'][
                    'nastroyka-tipov-dostupov'
                  ],
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting_Roles_accessTypes',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.inputs,
                      icon: 'interface-common-inputs',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_inputs',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-roles'][
                        'access-types_planning'
                      ].planirovanie,
                      icon: 'pages-planning',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_planning',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-roles'][
                        'access-types_sales'
                      ].prodazhi,
                      icon: 'pages-projects-sales',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_sales',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-roles'][
                        'access-types_time-control'
                      ]['kontrol-rabochego-vremeni'],
                      icon: 'pages-projects-statistic',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_timeControl',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-roles'][
                        'access-types_employees'
                      ]['sotrudniki'],
                      icon: 'pages-hr',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_employees',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-roles'][
                        'access-types_personal-area'
                      ]['lichnyy-kabinet'],
                      icon: 'pages-settings-personal_area',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_personalArea',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-roles'][
                        'access-types_setting'
                      ]['nastroyki'],
                      icon: 'IconsInterfaceSettings',
                      link: 'settingInterfaceWebSetting_Roles_accessTypes_setting',
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_Roles_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_Roles_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['polzovateli'],
              icon: 'pages-settings-users',
              link: 'settingInterfaceWebSetting_users',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_users_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.status,
                  icon: 'interface-common-status',
                  link: 'settingInterfaceWebSetting_users_status',
                },

                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_users_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-users']['dialog-add'][
                        'priglashenie-v-proapp'
                      ],
                      icon: 'interface-employee-invite',
                      link: 'settingInterfaceWebSetting_users_dialogs_add',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_users_dialogs_add_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_users_dialogs_add_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-users']['dialog-edit'][
                        'redaktirovanie-polzovatelya'
                      ],
                      icon: 'interface-common-edit',
                      link: 'settingInterfaceWebSetting_users_dialogs_edit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_users_dialogs_edit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_users_dialogs_edit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-users'][
                        'dialog-assign_role'
                      ]['naznachit-rol'],
                      icon: 'interface-employee-appoint',
                      link: 'settingInterfaceWebSetting_users_dialogs_assignRole',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_users_dialogs_assignRole_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_users_dialogs_assignRole_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_users_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages.offer_agreement,
              icon: 'pages-settings-offer_agreement',
              link: 'settingInterfaceWebSetting_offerAgreement',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting_offerAgreement_buttons',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_offerAgreement_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.labels,
                  icon: 'interface-common-labels',
                  link: 'settingInterfaceWebSetting_offerAgreement_labels',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tooltips,
                  icon: 'interface-common-tooltips',
                  link: 'settingInterfaceWebSetting_offerAgreement_tooltips',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_offerAgreement_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-offer_agreement'][
                        'dialog-publish-buttons'
                      ].publish,
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_offerAgreement_dialogs_publish',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_offerAgreement_dialogs_publish_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-offer_agreement'][
                        'dialog-confirm'
                      ].titles,
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_offerAgreement_dialogs_confirm',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_offerAgreement_dialogs_confirm_buttons',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages[
                'administrirovanie-interfeysa'
              ],
              icon: 'pages-settings-interface',
              link: 'settingInterfaceWebSetting_interface',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.elements,
                  icon: 'interface-common',
                  link: 'settingInterfaceWebSetting_interface_common',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.texts,
                  icon: 'interface-common-text',
                  link: 'settingInterfaceWebSetting_interface_text',
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages[
                'segmenty-vida-deyatelnosti'
              ],
              icon: 'pages-settings-business_segment',
              link: 'settingInterfaceWebSetting_businessSegment',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_businessSegment_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_businessSegment_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .inputs,
                          icon: 'interface-common-inputs',
                          link: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit_inputs',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_businessSegment_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_businessSegment_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['tipy-proektov'],
              icon: 'pages-settings-project_type',
              link: 'settingInterfaceWebSetting_projectType',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_projectType_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_projectType_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_projectType_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_projectType_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .inputs,
                          icon: 'interface-common-inputs',
                          link: 'settingInterfaceWebSetting_projectType_dialogs_addEdit_inputs',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_projectType_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_projectType_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['kategorii-rabot'],
              icon: 'pages-settings-work_types_category',
              link: 'settingInterfaceWebSetting_workTypeCategory',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_workTypeCategory_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_workTypeCategory_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .inputs,
                          icon: 'interface-common-inputs',
                          link: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit_inputs',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_workTypeCategory_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_workTypeCategory_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['vidy-rabot'],
              icon: 'pages-settings-work_types',
              link: 'settingInterfaceWebSetting_workType',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_workType_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_workType_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_workType_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_workType_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_workType_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_workType_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['vidy-dopolnitelnyh-rabot'],
              icon: 'pages-settings-work_extra_type',
              link: 'settingInterfaceWebSetting_workExtraType',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_workExtraType_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_workExtraType_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_workExtraType_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_workExtraType_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_workExtraType_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_workExtraType_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['regiony'],
              icon: 'pages-settings-work_region',
              link: 'settingInterfaceWebSetting_region',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_region_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_region_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_region_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_region_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_region_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_region_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['dolzhnosti'],
              icon: 'interface-employee-appoint',
              link: 'settingInterfaceWebSetting_employeeRoles',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_employeeRoles_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_employeeRoles_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_employeeRoles_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_employeeRoles_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_employeeRoles_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_employeeRoles_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['tip-chertezha'],
              icon: 'pages-settings-scheme_type',
              link: 'settingInterfaceWebSetting_schemeType',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_schemeType_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_schemeType_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_schemeType_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_schemeType_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_schemeType_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_schemeType_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['tip-dokumenta'],
              icon: 'pages-settings-document_type',
              link: 'settingInterfaceWebSetting_documentType',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_documentType_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_documentType_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_documentType_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_documentType_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_documentType_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_documentType_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['zona-raboty'],
              icon: 'pages-settings-work_area',
              link: 'settingInterfaceWebSetting_workArea',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_workArea_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_workArea_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_workArea_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_workArea_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_workArea_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_workArea_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['soderzhanie-chertezhey'],
              icon: 'pages-settings-scheme_class',
              link: 'settingInterfaceWebSetting_schemeСlass',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebSetting_schemeСlass_tables',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting_schemeСlass_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebSetting_schemeСlass_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSetting_schemeСlass_dialogs_addEdit_labels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSetting_schemeСlass_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSetting_schemeСlass_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['structure_company'],
              icon: 'pages-settings-structure_company',
              link: 'settingInterfaceWebSetting_structureCompany',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.titles,
                  icon: 'interface-common-titles',
                  link: 'settingInterfaceWebSetting_structureCompany_titles',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.labels,
                  icon: 'interface-common-labels',
                  link: 'settingInterfaceWebSetting_structureCompany_labels',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting_structureCompany_buttons',
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.setting.pages['setting_company'],
              icon: 'pages-settings-company',
              link: 'settingInterfaceWebSetting_settingCompany',
            },
            {
              text: this.localStorage.translations.pages.setting.pages['push_notifications'],
              icon: 'pages-settings-push_notifications',
              link: 'settingInterfaceWebSetting-pushNotifications',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-push_notifications'].main.status,
                  icon: 'interface-common-titles',
                  link: 'settingInterfaceWebSetting-pushNotifications-statuses',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebSetting-pushNotifications-dialogs',
                },
                {
                  text: this.localStorage.translations.pages['setting-push_notifications'].main.type,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting-pushNotifications-types',
                },
                {
                  text: this.localStorage.translations.pages['setting-push_notifications'].main.trigger,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSetting-pushNotifications-triggers',
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.pages.buttons.finance,
              icon: 'pages-finance',
              link: 'settingInterfaceWebSettingFinance',
            },
          ],
        },
        {
          text: this.localStorage.translations.pages.chat.all.chat,
          icon: 'chat-main',
          link: 'settingInterfaceWebChat',
        },
        {
          text: this.localStorage.translations.pages.pages.buttons.glavnaya,
          icon: 'interface-common-pages',
          link: 'settingInterfaceWebHome',
        },
        {
          text: this.localStorage.translations.pages.pages.buttons.planirovanie,
          icon: 'pages-planning',
          link: 'settingInterfaceWebPlanning',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWebPlanningPages',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.tables,
              icon: 'interface-common-tables',
              link: 'settingInterfaceWebPlanningOrdersTable',
            },
          ],
        },
        {
          text: this.localStorage.translations.pages.pages.buttons.prodazhi,
          icon: 'pages-projects-sales',
          link: 'settingInterfaceWebSales',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWebSalesPages',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceWebSalesButtons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.status,
              icon: 'interface-common-status',
              link: 'settingInterfaceWebSalesStatus',
            },
            {
              text: this.localStorage.translations.pages.pages.buttons.proekty,
              icon: 'pages-projects',
              link: 'settingInterfaceWebSalesProject',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common
                    .sections_name,
                  icon: 'interface-projects-sections_titles',
                  link: 'settingInterfaceWebSalesProjectSections',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWebSalesProjectButtons',
                },
                {
                  text: this.localStorage.translations.pages.sales_project.sections[
                    'proektnye-i-klientskie-dannye'
                  ],
                  icon: 'interface-projects-project_client',
                  link: 'settingInterfaceWebSalesProjectProjectClient',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .sections_name,
                      icon: 'interface-projects-sections',
                      link: 'settingInterfaceWebSalesProjectProjectClientSections',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .buttons,
                      icon: 'interface-common-buttons',
                      link: 'settingInterfaceWebSalesProjectProjectClientButtons',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.labels,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWebSalesProjectProjectClientLabels',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.inputs,
                      icon: 'interface-common-inputs',
                      link: 'settingInterfaceWebSalesProjectProjectClientInputs',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .tooltips,
                      icon: 'interface-common-tooltips',
                      link: 'settingInterfaceWebSalesProjectProjectClientTooltips',
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages.sales_project.sections[
                    'chertezhi-i-dokumenty'
                  ],
                  icon: 'interface-projects-schemes_documents',
                  link: 'settingInterfaceWebSalesProjectSchemesDocuments',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .sections_name,
                      icon: 'interface-projects-sections',
                      link: 'settingInterfaceWebSalesProjectSchemesDocumentsSections',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .tooltips,
                      icon: 'interface-common-tooltips',
                      link: 'settingInterfaceWebSalesProjectSchemesDocumentsTooltips',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.tables,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWebSalesProjectSchemesDocumentsTables',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebSalesProjectSchemesDocumentsDelete',
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages.sales_project.sections[
                    'materialy-i-tseny'
                  ],
                  icon: 'interface-projects-material_price',
                  link: 'settingInterfaceWebSalesProjectMaterialPrice',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.tables,
                      icon: 'interface-common-tables',
                      link: 'settingInterfaceWebSalesProjectMaterialPriceTables',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .tooltips,
                      icon: 'interface-common-tooltips',
                      link: 'settingInterfaceWebSalesProjectMaterialPriceTooltips',
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages.sales_project.sections[
                    'planiruemye-resursy'
                  ],
                  icon: 'pages-projects-sales',
                  link: 'settingInterfaceWebSalesProjectPlannedResources',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.labels,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWebSalesProjectPlannedResourcesLabels',
                    },
                    {
                      text: this.localStorage.translations.pages.sales_project[
                        'planned_resources-time_period'
                      ]['main'],
                      icon: 'pages-projects-sales',
                      link: 'settingInterfaceWebSalesProjectPlannedResourcesPeriod',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodLabels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .inputs,
                          icon: 'interface-common-inputs',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodInputs',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .tooltips,
                          icon: 'interface-common-tooltips',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodTooltips',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .delete,
                          icon: 'interface-common-delete',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesPeriodDelete',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['sales_project'][
                        'planned_resources-subscribers'
                      ].title,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWebSalesProjectPlannedResourcesSubscribers',
                    },
                    {
                      text: this.localStorage.translations.pages.sales_project[
                        'planned_resources-responsible_employees'
                      ]['main'],
                      icon: 'pages-projects-sales',
                      link: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployees',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployeesLabels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployeesButtons',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .delete,
                          icon: 'interface-common-delete',
                          link: 'settingInterfaceWebSalesProjectPlannedResourcesResponsibleEmployeesDelete',
                        },
                      ],
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages.sales_project.price_offer_terms[
                    'title'
                  ],
                  icon: 'pages-projects-sales',
                  link: 'settingInterfaceWebSalesProject_priceOfferTerms',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.labels,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWebSalesProject_priceOfferTerms_labels',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.tables,
                      icon: 'interface-common-tables',
                      link: 'settingInterfaceWebSalesProject_priceOfferTerms_tables',
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          text: this.localStorage.translations.pages.pages.buttons.proekty,
          icon: 'pages-projects',
          link: 'settingInterfaceWebProjects',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWebProjectsPages',
            },
            {
              text: this.localStorage.translations.pages['projects'].pages.statistics,
              icon: 'pages-projects-statistic',
              link: 'settingInterfaceWebProjectsStatistic',
              childrens: [
                {
                  text: this.localStorage.translations.pages.pages.buttons.proekty,
                  icon: 'pages-projects',
                  link: 'settingInterfaceWebProjectsStatisticProject',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.tables,
                      icon: 'interface-common-tables',
                      link: 'settingInterfaceWebProjectsStatisticProjectTables',
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages.personnel_department.pages.sotrudniki,
                  icon: 'pages-hr-employees',
                  link: 'settingInterfaceWebProjectsStatisticEmployee',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.tables,
                      icon: 'interface-common-tables',
                      link: 'settingInterfaceWebProjectsStatisticEmployeeTables',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages['projects'].pages.reports,
              icon: 'pages-projects-statistic',
              link: 'settingInterfaceWebProjectsReports',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebProjectsReportsTables',
                },

                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebProjectsReportsDialogs',
                },
              ],
            },
          ],
        },
        {
          text: this.localStorage.translations.pages.pages.buttons['otdel-kadrov'],
          icon: 'pages-hr',
          link: 'settingInterfaceWebPersonnelDepartment',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWebPersonnelDepartmentPages',
            },
            {
              text: this.localStorage.translations.pages.personnel_department.pages.sotrudniki,
              icon: 'pages-hr-employees',
              link: 'settingInterfaceWebPersonnelDepartmentEmployees',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages.personnel_department
                        .dialog_addemployee_buttons['dobavit-sotrudnika'],
                      icon: 'interface-employee-add',
                      link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsAdd',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsAddButtons',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsAddLabels',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages.personnel_department
                        .dialog_employeeinvitation_buttons['priglashenie-sotrudnika-v-proapp'],
                      icon: 'interface-employee-invite',
                      link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitation',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitationButtons',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitationLabels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .inputs,
                          icon: 'interface-common-inputs',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsInvitationInputs',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages.personnel_department
                        .dialog_employeepositionappointment_buttons['naznachit-dolzhnost'],
                      icon: 'interface-employee-appoint',
                      link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointment',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointmentnButtons',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointmentLabels',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .inputs,
                          icon: 'interface-common-inputs',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesDialogsPositionAppointmentInputs',
                        },
                      ],
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages.personnel_department.employees_card
                    .main,
                  icon: 'interface-employee-card',
                  link: 'settingInterfaceWebPersonnelDepartmentEmployeesCard',
                },
              ],
            },
            {
              text: this.localStorage.translations.pages.personnel_department.pages.podrazdeleniya,
              icon: 'pages-hr-employees_group',
              link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroup',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.sections,
                  icon: 'interface-common-sections',
                  link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupSections',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsCreateEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsCreateEditButtons',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsCreateEditLabels',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsDelete',
                    },
                    {
                      text: this.localStorage.translations.pages.personnel_department[
                        'employees_group-dialog-additional_project-buttons'
                      ].add,
                      icon: 'interface-employee-appoint',
                      link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProject',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProjectButtons',
                        },
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .labels,
                          icon: 'interface-common-labels',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProjectLabels',
                        },
                        {
                          text: 'Уделение',
                          icon: 'interface-common-delete',
                          link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupDialogsAdditionalProjectDelete',
                        },
                      ],
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.tables,
                  icon: 'interface-common-tables',
                  link: 'settingInterfaceWebPersonnelDepartmentEmployeesGroupTables',
                },
              ],
            },
          ],
        },
        {
          text: this.localStorage.translations.pages.setting.pages['klienty'],
          icon: 'pages-clients',
          link: 'settingInterfaceWeb_clients',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.tables,
              icon: 'interface-common-tables',
              link: 'settingInterfaceWeb_clients_tables',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
              icon: 'interface-common-dialogs',
              link: 'settingInterfaceWeb_clients_dialogs',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common[
                    'dialogs-add_edit'
                  ],
                  icon: 'interface-common-add_edit',
                  link: 'settingInterfaceWeb_clients_dialogs_addEdit',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.labels,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWeb_clients_dialogs_addEdit_labels',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .buttons,
                      icon: 'interface-common-buttons',
                      link: 'settingInterfaceWeb_clients_dialogs_addEdit_buttons',
                    },
                  ],
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.delete,
                  icon: 'interface-common-delete',
                  link: 'settingInterfaceWeb_clients_dialogs_delete',
                },
                {
                  text: this.localStorage.translations.pages['setting-client']['dialog-adress'][
                    'main'
                  ],
                  icon: 'interface-common-adress_check',
                  link: 'settingInterfaceWeb_clients_dialogs_address',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.labels,
                      icon: 'interface-common-labels',
                      link: 'settingInterfaceWeb_clients_dialogs_address_labels',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .buttons,
                      icon: 'interface-common-buttons',
                      link: 'settingInterfaceWeb_clients_dialogs_address_buttons',
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common
                        .checkbox,
                      icon: 'interface-common-checkbox',
                      link: 'settingInterfaceWeb_clients_dialogs_address_checkbox',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages['setting-client']['address']['adresa'],
              icon: 'interface-common-adress',
              link: 'settingInterfaceWeb_clients_address',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWeb_clients_address_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWeb_clients_address_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWeb_clients_address_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWeb_clients_address_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages['setting-client']['contacts']['kontakty'],
              icon: 'interface-common-contacts',
              link: 'settingInterfaceWeb_clients_contacts',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWeb_clients_contacts_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWeb_clients_contacts_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWeb_clients_contacts_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWeb_clients_contacts_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages['setting-client']['persons'][
                'kontaktnye-litsa'
              ],
              icon: 'pages-hr-employees',
              link: 'settingInterfaceWeb_clients_persons',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWeb_clients_persons_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWeb_clients_persons_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWeb_clients_persons_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWeb_clients_persons_dialogs_delete',
                    },
                  ],
                },
              ],
            },
            {
              text: this.localStorage.translations.pages['setting-client']['offices']['filialy'],
              icon: 'interface-common-offices',
              link: 'settingInterfaceWeb_clients_offices',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
                  icon: 'interface-common-dialogs',
                  link: 'settingInterfaceWeb_clients_offices_dialogs',
                  childrens: [
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common[
                        'dialogs-add_edit'
                      ],
                      icon: 'interface-common-add_edit',
                      link: 'settingInterfaceWeb_clients_offices_dialogs_addEdit',
                      childrens: [
                        {
                          text: this.localStorage.translations.pages['setting-interface'].common
                            .buttons,
                          icon: 'interface-common-buttons',
                          link: 'settingInterfaceWeb_clients_offices_dialogs_addEdit_buttons',
                        },
                      ],
                    },
                    {
                      text: this.localStorage.translations.pages['setting-interface'].common.delete,
                      icon: 'interface-common-delete',
                      link: 'settingInterfaceWeb_clients_offices_dialogs_delete',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          text: this.localStorage.translations.pages.pages.buttons.finance,
          icon: 'pages-finance',
          link: 'settingInterfaceWebFinance',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWebFinancePages',
            },
            {
              text: this.localStorage.translations.pages.finance.pages.salary,
              icon: 'interface-common-tables',
              link: 'settingInterfaceWebFinanceSalary',
            },
            {
              text: this.localStorage.translations.pages.projects.pages.reports,
              icon: 'pages-finance-salary',
              link: 'settingInterfaceWebFinancePeriod',
            },
            {
              text: this.localStorage.translations.pages.finance.pages.invoice,
              icon: 'pages-finance-invoice',
              link: 'settingInterfaceWebFinanceInvoice',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.status,
              icon: 'pages-finance-invoice',
              link: 'settingInterfaceWebFinanceInvoiceStatus',
            },
          ]
        },
        {
          text: this.localStorage.translations.pages.setting.pages['free_documents'],
          icon: 'pages-documents',
          link: 'settingInterfaceWeb_freeDocuments',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pages_name,
              icon: 'interface-common-pages_second',
              link: 'settingInterfaceWeb_freeDocuments_pages',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.tables,
              icon: 'interface-common-tables',
              link: 'settingInterfaceWeb_freeDocuments_tables',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.dialogs,
              icon: 'interface-common-dialogs',
              link: 'settingInterfaceWeb_freeDocuments_dialogs',
              childrens: [
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.titles,
                  icon: 'interface-common-titles',
                  link: 'settingInterfaceWeb_freeDocuments_dialogs_titles',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.labels,
                  icon: 'interface-common-labels',
                  link: 'settingInterfaceWeb_freeDocuments_dialogs_labels',
                },
                {
                  text: this.localStorage.translations.pages['setting-interface'].common.buttons,
                  icon: 'interface-common-buttons',
                  link: 'settingInterfaceWeb_freeDocuments_dialogs_buttons',
                },
              ],
            },
          ],
        },
        {
          text: this.localStorage.translations.pages['setting-interface'].common.auth,
          icon: 'interface-auth',
          link: 'settingInterfaceWeb_auth',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.titles,
              icon: 'interface-common-titles',
              link: 'settingInterfaceWeb_auth_titles',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.labels,
              icon: 'interface-common-labels',
              link: 'settingInterfaceWeb_auth_labels',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceWeb_auth_buttons',
            },
          ],
        },
        {
          text: this.localStorage.translations.pages['setting-interface'].common.elements,
          icon: 'interface-common',
          link: 'settingInterfaceWeb_commonElements',
          childrens: [
            {
              text: this.localStorage.translations.pages['setting-interface'].common.notifications,
              icon: 'interface-common-notifications',
              link: 'settingInterfaceWeb_commonElements_notifications',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.pagination,
              icon: 'interface-common-pagination',
              link: 'settingInterfaceWeb_commonElements_pagination',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.buttons,
              icon: 'interface-common-buttons',
              link: 'settingInterfaceWeb_commonElements_buttons',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.inputs_error,
              icon: 'interface-common-inputs_error',
              link: 'settingInterfaceWeb_commonElements_rules',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.breadcrumbs,
              icon: 'interface-common-breadcrumbs',
              link: 'settingInterfaceWeb_commonElements_breadcrumbs',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.texts,
              icon: 'interface-common-text',
              link: 'settingInterfaceWeb_commonElements_text',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.checkbox,
              icon: 'interface-common-checkbox',
              link: 'settingInterfaceWeb_commonElements_checkbox',
            },
            {
              text: this.localStorage.translations.pages['setting-interface'].common.measure,
              icon: 'interface-common-measure',
              link: 'settingInterfaceWeb_commonElements_measure',
            },
          ],
        },
        {
          text: '404',
          icon: 'interface-404',
          link: 'settingInterfaceWeb_error',
        },
        {
          text: this.localStorage.translations.pages['setting-interface'].common.footer,
          icon: 'interface-footer',
          link: 'settingInterfaceWebFooter',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>
